import React from 'react'
import niv from './photolic/nivesh.jpg'
import './image.css'
const Nivesh = () => {
  return (
    <div>
      <img src={niv} alt="" className='eimg'/>
    </div>
  )
}

export default Nivesh
